// Persists the user's last known location so a non-GPS device (a laptop) can
// reopen the map somewhere useful instead of the London default every time.
// plan.md §4.1 wanted an IP-based fallback; remembering a place the user
// deliberately chose (or a prior GPS fix) is simpler, needs no third party,
// and stays anonymous — the value never leaves the browser.
//
// localStorage access is wrapped because Safari's private mode throws on
// setItem and embedded webviews can throw on access; either way the app must
// carry on with the in-memory default.

const KEY = 'reporter:last-location';

export function getLastLocation() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const loc = JSON.parse(raw);
    if (typeof loc.lat !== 'number' || typeof loc.lng !== 'number') return null;
    return loc;
  } catch {
    return null;
  }
}

export function setLastLocation(loc) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...loc, ts: Date.now() }));
  } catch {
    // Ignore — private mode / storage disabled. The map still works.
  }
}
